<template>
  <div class="main-content-container">
    <div class="top-content-container position-relative">
      <b-breadcrumb class="pb-2">
        <b-breadcrumb-item>
          <span @click="$router.push({ name: 'Resources' })" class="breadcrumb--light font-family-medium text-uppercase">
            Resources
          </span>
        </b-breadcrumb-item>
        <b-breadcrumb-item>
          <span class="breadcrumb--light font-family-medium text-uppercase">
            <span @click="$router.push({ name: 'TipsList' })" class="breadcrumb--light font-family-medium text-uppercase">
              Tips
            </span>
          </span>
        </b-breadcrumb-item>
        <b-breadcrumb-item active>
          <span class="breadcrumb--light font-family-medium text-uppercase">
            Add Tip
          </span>
        </b-breadcrumb-item>
      </b-breadcrumb>
      <div class="d-flex flex-row justify-content-between">
        <h1 class="font-lg font-family-medium primary-dark content-title">
          Add Tip
        </h1>
      </div>
    </div>
    <b-dropdown-divider class="mt-4 mb-4" />
    <b-row>
      <b-col cols="12" xl="6">
        <ValidationObserver ref="form">
          <ValidationProvider name="tipText" rules="required|maxLengthTip" v-slot="{ errors }">
            <b-form-group label="Tip data *" class="mb-5 mt-5 add-view-tip-form-group">
              <b-form-input size="lg" type="text" v-model="tip_text" class="add-tip-name"
                placeholder="Add tip"></b-form-input>
              <h6 v-if="errors[0]" data-cy="tip-add-error-text"
                class="add-tip-text-err font-sm font-family-regular danger normalize-zIndex">
                {{ errors[0] }}
              </h6>
            </b-form-group>
          </ValidationProvider>
          <b-form-group label="Tip hyperlink title" class="mb-5 mt-5 add-view-tip-form-group">
            <b-form-input data-cy="input-tip-link-title" id="input-tip-link-title" name="input-tip-link-title"
              v-model="link_title"
              placeholder="Enter Link Title (should match the hyperlink text of tip data, without double-quotes)"></b-form-input>
          </b-form-group>
          <ValidationProvider rules="validUrl" v-slot="{ errors }">
            <b-form-group label="Tip hyperlink URL" class="mb-5 mt-5 add-view-tip-form-group">
              <b-form-input data-cy="input-tip-link" id="input-tip-link-url" v-model="link_url"
                placeholder="Enter Link URL" @keyup="onLinkUrlKeyup"></b-form-input>
              <h6 v-if="errors[0]" data-cy="tip-add-error-link"
                class="add-tip-text-err font-sm font-family-regular danger normalize-zIndex">
                {{ errors[0] }}
              </h6>
              <div data-cy="link-url-error" v-if="linkError && linkError.linkUrl" class="linkTitleError error-msg">
                {{ linkError.linkUrl[0] }}
              </div>
            </b-form-group>
          </ValidationProvider>
        </ValidationObserver>
      </b-col>
    </b-row>
    <b-row v-if="showValidity && !showError" class="mx-0 mb-2" align-v="center">
      <b-alert :show="showValidity" class="add-tip-success alert-btn-top w-100 custom-alert add-tip-alert mb-2 mt-1">
        {{ message }}
      </b-alert>
    </b-row>
    <b-row v-if="showError" class="mx-0 mb-2" align-v="center">
      <b-alert :show="showError" class="alert-btn-top w-100 custom-alert add-tip-alert mb-2 mt-1">
        {{ error }}
      </b-alert>
    </b-row>
    <b-row class='save-button-row' v-if="isAdmin()">
      <b-col cols="12">
        <div>
          <b-button class="add-tip-save save-button px-5 py-3 btn-pill" @click="addTip" :disabled="disableFields">
            <b-spinner v-if="saveLoader" style="width: 14px; height: 14px" variant="light" label="Spinning"></b-spinner>
            <template v-else>Save</template>
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
  
<script>
import { getTips, postTip } from "@/apis/common/index";
import {
  ValidationProvider,
  ValidationObserver,
  extend
} from "vee-validate/dist/vee-validate.full";
import { isAdmin } from '@/utils/utils'

extend("required", {
  message: () => "This is a required field"
});
let maxLengthTipMsg = "";
extend("maxLengthTip", {
  message: () => `${maxLengthTipMsg}`,
  validate: value => {
    if (value.length <= 300) {
      return true;
    } else {
      maxLengthTipMsg = "Title can contain only 300 characters";
      return false;
    }
  }
});
let validUrlMsg = "";
extend("validUrl", {
  message: () => `${validUrlMsg}`,
  validate: value => {
    const urlPattern = /^(ftp|http|https):\/\/[^ "]+$/;
    if (urlPattern.test(value)) {
      return true;
    } else {
      validUrlMsg = "URL should start with http:// or https://";
      return false;
    }
  }
});

export default {
  name: "AddTip",
  components: {
    ValidationObserver,
    ValidationProvider,
  },

  data() {
    return {
      URL: window.URL,
      message: "",
      disableFields: false,
      tipText: "",
      isUsed: false,
      showValidity: false,
      showError: false,
      tip_list: [],
      tip_text: "",
      link_title: "",
      link_url: "",
      linkError: null,
      tipID: "",
      error: "Some error occured",
      saveLoader: false,
      viewLoading: true,
      isLoading: false,
      isLoadingTips: true,
    }
  },
  methods: {
    isAdmin,
    fetchTipList() {
      getTips()
        .then(res => {
          this.tip_list = [...res.data.results];
        })
        .catch(err => {
          console.log(err);
          this.isLoadingTips = false;
        })
        .finally(() => {
          this.isLoadingTips = false;
        });
    },
    async addTip() {
      this.showError = false;
      this.showValidity = false;
      this.saveLoader = true;
      this.isLoading = true;
      const valid = await this.$refs.form.validate();
      if (!valid) {
        this.showValidity = true;
        this.message = "There are invalid form fields";
        this.saveLoader = false;
        return;
      };
      if ((!this.link_title && this.link_url) || (!this.link_url && this.link_title)) {
        this.showValidity = true;
        this.message = "Both Tip hyperlink title and Tip hyperlink url are required, if any one of them is filled";
        this.saveLoader = false;
        return;
      }
      const regex = new RegExp(`\\b${this.link_title}\\b`, 'i');
      if (this.link_title && this.tip_text.match(regex) == null) {
        this.showValidity = true;
        this.message = "Tip hyperlink title should match with tip data";
        this.saveLoader = false;
        return;
      }
      const payload = {
        tip_text: this.tip_text,
        link_text: this.link_title,
        link_url: this.link_url
      };
      try {
        let res = await postTip(payload);
        if (res.status == 201) {
          this.$router.push({
            name: 'TipsList'
          })
        }
        this.tipID = res.data.id;
      } catch (e) {
        this.saveLoader = false;
        if (e.response.status === 401) {
          this.error = "User token expired. Please logout and login again."
        }
        else if (e.response.status === 400 && e.response?.data) {
          this.linkError = e.response.data;
        }
        else {
          this.showError = true;
          this.error = "Some error occured";
        }
      } finally {
        this.saveLoader = false
        this.isLoading = false
      }
    },
    onLinkUrlKeyup() {
      this.linkError && (this.linkError.linkUrl = null);
    }
  }
};
</script>
  
<style scoped lang="scss">
@import "~@/scss/variables/colors.scss";
@import "~@/scss/variables/helpers.scss";
@import "~@/scss/common/fonts.scss";

.main-content-container {
  // giving the container a fixed height and making it scrollable to facilitate
  // scrolling while dragging a checklist item, since body does not scroll
  // https://github.com/kutlugsahin/vue-smooth-dnd/issues/18
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - #{$navbar-height});
}

.save-button-row {
  padding-top: 15px;
  padding-bottom: 15px;

  button.save-button {
    background: $button-secondary;
  }

  >div {
    display: flex;

    >div {
      padding-right: 10px;
    }
  }
}

.error-msg {
  color: var(--td-btn-primary, #8f00ff);
  font-size: $font-size-xs;
}
</style>